export default __webpack_public_path__ + "static/media/goshen1.d5fedd15.jpg";